import { T } from 'react-translator-component';

import { canModerateInteroperability } from '../../../utils/canModerateInteroperability/canModerateInteroperability';

/**
 * As abas do módulo (MV2-1712).
 *
 * Quatro nasceram em subtarefa própria — F2, F8, F6 e F7. A de Convites veio depois,
 * porque convite gerado saía de vista: o banner só mostra recebido pendente, e usado,
 * expirado e revogado não apareciam em lugar nenhum.
 *
 * O mapa de ligações deixou de ser aba: ele e Conexões respondiam a mesma pergunta — quais
 * contratos existem e com quem —, e duas abas para uma pergunta obrigam a escolher antes de
 * saber qual das duas responde.
 *
 * Aqui fica só a definição, para o shell não precisar conhecer o conteúdo de nenhuma.
 */
export type InteroperabilityTabKey =
  | 'invites'
  | 'connections'
  | 'stations'
  | 'transactions'
  | 'audit'
  | 'api'
  | 'eligibility';

export type InteroperabilityTab = {
  key: InteroperabilityTabKey;
  label: string;
};

export const INTEROPERABILITY_TABS = (): InteroperabilityTab[] => [
  // Ordem por ciclo de vida (esquerda -> direita): primeiro se a conta pode participar,
  // depois o convite vira contrato, o contrato entrega estações, as estações geram
  // transações, o histórico, e a API (config de desenvolvedor) no fim.
  //
  // Elegibilidade é o portão (só para quem modera): liga/desliga can_tenant_bind da conta e
  // dos descendentes. Ação sensível (abre replicação de dados), por isso atrás de permissão.
  ...(canModerateInteroperability() ? [{ key: 'eligibility' as const, label: T('Eligibility') }] : []),
  { key: 'invites', label: T('Invites') },
  // O mapa de ligações vive DENTRO desta, como uma segunda forma de olhar os mesmos
  // contratos — era aba própria e respondia a mesma pergunta.
  { key: 'connections', label: T('Connections') },
  // A única que fala do que o contrato entrega, e não do contrato em si.
  { key: 'stations', label: T('Stations') },
  { key: 'transactions', label: T('Transactions') },
  { key: 'audit', label: T('Audit') },
  // Por último: é configuração da conta, não operação do dia. Chamada de API porque é o
  // que a pessoa vem procurar aqui — a chave de acesso e a documentação dos endpoints.
  { key: 'api', label: T('API') },
];
